/*
 * Daellia ring sizes by country.
 * The sticky add-to-cart bar prints the variant title in US sizes ("White Gold / 6").
 * When the buyer's country uses another system, rewrite the size part ("White Gold / UK L½").
 * The size map comes from snippets/dl-ring-size-note.liquid.
 */
(function () {
  if (window.__dlRingSizeInit) return;
  window.__dlRingSizeInit = true;

  function readConfig(productId) {
    var selector = 'script[data-dl-ring-map]';
    if (productId) selector += '[data-product-id="' + productId + '"]';
    var el = document.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function fix(node, productId) {
    var config = readConfig(productId);
    if (!config || !config.labels) return;

    var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return;

    var parts = text.split(' / ');
    var index = Number(config.index);
    if (isNaN(index) || index < 0 || index >= parts.length) return;

    var label = config.labels[parts[index].trim()];
    if (!label) return;

    parts[index] = config.prefix + ' ' + label;
    var next = parts.join(' / ');
    if (next !== text) node.textContent = next;
  }

  function init() {
    document.querySelectorAll('sticky-add-to-cart').forEach(function (sticky) {
      var productId = sticky.getAttribute('data-product-id');
      var node = sticky.querySelector('.sticky-add-to-cart__variant');
      if (!node) return;
      fix(node, productId);
      new MutationObserver(function () {
        fix(node, productId);
      }).observe(node, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
